export const dashboardAdminTranslation = {

  // section title
  manage_dashboards_title: 8718,

  // header
  add_new: 6943,

  // search
  search: 7345,
  search_hits: 7474,
  search_no_dashboards: 8719,

  // messages
  no_access_to_dashboard_admin: 8720,
  dashboard_deleted: 8721,

  // list item
  disabled: 5251,
  open_dashboard: 8722,
  edit_dashboard: 8723,
  edit_saved_reports: 9360,
  edit_dashboard_preview: 8724,
  delete_dashboard_title: 8725,
  delete_dashboard_button: 9361,

  // confirmation
  delete_confirmation: 8726,
  cancel: 3273,

  // prompt unsaved
  cancel_changes: 7558,
  are_you_sure: 7460,
  undo_all: 5792,
  go_back: 7966,

  // form messages
  dashboard_created: 8727,
  dashboard_updated: 8728,
  fields_are_filled_out_incorrectly: 8206,
  saving_dashboard: 8730,
  deleting_dashboard: 8731,

  // form header
  save_dashboard_button: 8732,
  new_dashboard: 8734,

  // form tabs
  switch_to_scroll: 7977,
  switch_to_tab: 7978,

  // sections
  details: 8044,
  visibility: 8394,
  descriptions_and_translations: 8391,
  saved_reports: 7991,

  // language
  translations_header: 8364,
  show_translations: 8393,
  description: 7278,
  copy_description_to_all: 8386,
  copied_description_to_all: 8388,

  // fields
  sequence: 6825,
  access_mode: 8735,
  visible_for_user_groups: 8395,
  visible_for_case_types: 8396,
  visible_for_users_and_roles: 8736,

  // manage options
  manage_options: 8521,

  // validation
  must_be_filled_out: 5949,
  must_be_within_range: 7939,
  at_least_one_must_be_filled_out: 9053,

  // form saved reports
  show_details: 7640,
  hide_details: 7641,

  // connect to new dashboard popup
  connect_to_new_confirmation: 8753,
  connect_to_saved_reports: 8754,
  later: 8477,

  // saved report
  add_report: 8746,
  add_reports: 8835,
  add_report_by_id: 8845,
  add_new_report: 8945,
  saved_report_failed: 8756,
  show_disabled_elements: 8785,

  // saved report menu
  edit_connection: 8747,
  edit_report: 8329,
  no_rights_to_edit_report: 9844,
  remove: 7742,
  remove_all: 8435,
  move_up: 7743,
  move_down: 7538,

  // saved report modal
  add_saved_reports_title: 8844,
  saved_report: 8748,
  my_saved_report: 8749,
  saved_report_id: 8750,
  saved_report_hint: 8751,
  saved_report_info: 8752,
  minWidth: 8744,
  height: 8745,
  done: 7338,
  saved_id_validation: 8755,
  min_width_validation: 8794,

  // filters
  filters: 7556,
  filters_info: 8850,
  add_filters: 8846,

  required: 9054,

  no_default_value: 8847,
  use_default_value: 8848,

  filters_my_unit: 7714,
  filters_my_location: 7715,
  filters_person: 7767,
  filters_not_supported: 8834,

  filters_date_range_date_fixed_period: 3706,
  filters_date_range_date_interval: 3707,
  filters_date_range_from: 7567,
  filters_date_range_to: 7600
};

export type DashboardAdminTranslation = {
  readonly [T in keyof typeof dashboardAdminTranslation]: string
};

export const defaultWidth = 500;
export const minWidth = 200;
